<template>
  <div data-v-step="tree">
    <el-input placeholder="quick search" size="mini" class="quickSearch" v-model="quickSearch" clearable></el-input>
    <el-button
      v-show="!moveActive"
      type="primary"
      class="refreshButton"
      icon="el-icon-refresh"
      @click="reloadTree()"
    ></el-button>
    <el-button
      v-if="checkPermission('updatePoint')"
      v-show="!moveActive"
      type="primary"
      class="moveButton"
      icon="el-icon-rank"
      @click="moveActive = true"
    ></el-button>
    <el-button
      v-show="moveActive"
      type="primary"
      class="moveSaveButton"
      icon="el-icon-s-claim"
      @click="saveMoveNode()"
    ></el-button>
    <el-button
      v-show="moveActive"
      type="primary"
      class="refreshButton"
      icon="el-icon-s-release"
      @click="reloadTree()"
    ></el-button>
    <el-tree
      style="margin-top: 25px"
      v-bind:class="{ moving: moveActive }"
      ref="tree"
      v-loading="status.loading"
      :data="filteredTreeData"
      :show-checkbox="config.showCheckbox"
      default-expand-all
      node-key="_id"
      :props="options"
      highlight-current
      @node-click="nodeClick"
      @check="nodeChange"
      :expand-on-click-node="false"
      :draggable="moveActive"
      :allow-drop="allowDrop"
      :allow-drag="allowDrag"
      @node-drag-end="handleDragEnd"
    >
      <span class="custom-tree-node" slot-scope="{ node }">
        <span>
          <TreePoint
            v-if="node.data.nodeType == 'point'"
            :node="node"
            v-on:pointDeleted="pointDeleted"
            v-on:pointUpdated="pointUpdated"
          />
          <Group
            v-if="node.data.nodeType == 'group'"
            v-on:pointCreated="pointCreated"
            v-on:groupUpdated="groupUpdated"
            v-on:groupDeleted="groupDeleted"
            v-on:groupCreated="groupCreated"
            :node="node"
          />
        </span>
      </span>
    </el-tree>
    <el-dialog
      width="30%"
      :title="$t('tree.createGroup')"
      :visible.sync="showCreateRootGroup"
    >
      <CreateGroup
        :parentGroupId="'root'"
        v-on:cancelled="rootGroupCreateCancelled"
        v-on:created="rootGroupCreated"
      ></CreateGroup>
    </el-dialog>
  </div>
</template>

<script>
import TreePoint from "./Tree_Point";
import Group from "./Group";
import CreateGroup from "./CreateGroup";
import { mapActions, mapState } from "vuex";

export default {
  name: "TagTree",
  components: { TreePoint, Group, CreateGroup },
  data() {
    return {
      showCreateRootGroup: false,
      selectedNode: "",
      changesOfNodes: [],
      moveActive: false,
      tags: new Set(),
      quickSearch: "",
      options: {
        label: "name",
        children: "children",
        checkbox: false,
      },
      treeData: [],
    };
  },
  created() {
    this.$store.dispatch("tree/getTree");
  },
  mounted() {
    this.$refs.tree.setCheckedKeys(this.activePoints);
    this.$bus.on(this, "selectNodes", (nodes) => {
      this.$refs.tree.setCheckedKeys(nodes);
      this.nodeChange();
    });
  },
  computed: {
    ...mapState("tree", [
      "tree",
      "config",
      "status",
      "activePoints",
      "activeTags",
    ]),
    ...mapState('point',['points']),
    filteredTreeData() {
      let clone = JSON.parse(JSON.stringify(this.tree));
      return this.filterRecursively(clone,this.points, this.quickSearch);
    },
  },
  methods: {
    filterRecursively(array,points, text) {
      const getChildren = (result, object) => {
        
        const macAddressFilter = points.filter(x=>x.device).filter(x => new RegExp(text, 'i').test(x.device.macAddress)).map((x) => { return x._id })

        if (object.name.replace(/ /,'').toUpperCase().includes(text.toUpperCase()) || macAddressFilter.includes(object._id)) {
          result.push(object);
          return result;
        }
        if (Array.isArray(object.children)) {
          const children = object.children.reduce(getChildren, []);
          if (children.length) result.push({ ...object, children });
        }
        return result;
      };

      return array.reduce(getChildren, []);
    },
    ...mapActions("account", ["changePointTab"]),
    ...mapActions("tree", [
      "updateActiveTags",
      "updateActivePoints",
      "updatePaths",
      "updateCheckedNodes",
      "updateSelectedNode",
      "moveNodes",
    ]),
    reloadTree() {
      this.$store.dispatch("tree/getTree");

      this.$refs.tree.setCheckedKeys(this.activePoints);
      this.changesOfNodes = [];
      this.moveActive = false;
    },
    async selectAll() {
      let arr = [];
      await this.tree.map((x, i) => {
        arr[i] = x._id;
      });
      this.$refs.tree.setCheckedKeys(arr);
    },
    resetSelected() {
      this.$refs.tree.setCheckedKeys([]);
    },
    pointCreated(parentNode, data) {
      const newChild = {
        _id: data._id,
        label: data.name,
        type: data.type,
        children: [],
        name: data.name,
        tagCode: `$${data.tagCode}`,
        nodeType: "point",
      };
      if (!parentNode.data.children) {
        this.set(parentNode.data, "children", []);
      }
      parentNode.data.children.push(newChild);
      this.nodeChange();
      this.$store.dispatch("point/getPoints", this.activePoints);
      this.reloadTree();
    },
    rootGroupCreateCancelled() {
      this.showCreateRootGroup = false;
    },
    pointDeleted(node) {
      node.remove();
      this.nodeChange();
      this.$store.dispatch("point/getPoints", this.activePoints);
    },
    pointUpdated(node, data) {
      node.data.tagCode = `$${data.tagCode}`;
      node.data.name = data.name;
      node.data.type = data.type;
      this.nodeChange();
      this.reloadTree();
    },
    groupUpdated(node, data) {
      node.data.tagCode = data.tagCode;
      node.data.name = data.name;
      this.nodeChange();
      this.reloadTree();
    },
    groupDeleted(node) {
      node.remove();
      this.nodeChange();
    },
    groupCreated(node, data) {
      const newChild = {
        _id: data._id,
        label: data.name,
        children: [],
        name: data.name,
        tagCode: data.tagCode,
        nodeType: "group",
      };
      if (!node.data.children) {
        this.set(node.data, "children", []);
      }
      this.reloadTree();
      node.data.children.push(newChild);
    },
    rootGroupCreated(data) {
      const newChild = {
        _id: data._id,
        children: [],
        name: data.name,
        tagCode: data.tagCode,
        nodeType: "group",
      };
      this.treeData.push(newChild);
      this.showCreateRootGroup = false;
      this.$store.dispatch("tree/getTree");
    },
    filter() {
      this.filtered = this.profiles.filter((profile) =>
        this.tags.every((tag) => profile.tags.includes(tag))
      );
    },
    nodeClick(n) {
      if (n.nodeType == "point") {
        this.changePointTab(n._id);
      }
      this.updateSelectedNode(n);
    },
    nodeChange() {
      const paths = this.$refs.tree
        .getCheckedNodes(true, false)
        .map((node) => this.$refs.tree.getNodePath(node).map((x) => x.tagCode));
      this.updatePaths(paths);
      this.updateCheckedNodes(this.$refs.tree.getCheckedNodes(false, true));

      let tags = [
        ...new Set(
          this.$refs.tree.getCheckedNodes(false, false).map((x) => x.tagCode)
        ),
      ];
      let points = [
        ...new Set(
          this.$refs.tree
            .getCheckedNodes(true, false)
            .filter((x) => x.nodeType == "point")
            .map((x) => x._id)
        ),
      ];
      this.updateActiveTags(tags);
      this.updateActivePoints(points);
    },
    editNode(node, e) {
      console.log(e);
      node.startEditing();
    },

    removeNode(node) {
      if (confirm("Are you sure?")) {
        node.remove();
      }
    },

    addChildNode(node) {
      if (node.enabled()) {
        let newNode = node.append({
          text: "New Node",
          data: { tagCode: "NEW", isPoint: false },
        });
        newNode.data.tagCode = String(newNode.text).toUpperCase();
        // newNode.select();
      }
    },

    addPoint(node) {
      if (node.enabled()) {
        let newNode = node.append({
          text: "New Point",
          data: { tagCode: "NEW", isPoint: true },
        });
        newNode.data.tagCode = String(newNode.text).toUpperCase();
        // newNode.select();
      }
    },
    dropCheck(dropNode, dataType) {
      if (dataType == "group") {
        return (
          dropNode.childNodes.some((x) => {
            return x.data.nodeType == "group";
          }) || !dropNode.childNodes.length
        );
      } else if (dataType == "point") {
        return (
          dropNode.childNodes.some((x) => {
            return x.data.nodeType == "point";
          }) || !dropNode.childNodes.length
        );
      } else {
        return false;
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      if (type == "inner") {
        if (
          draggingNode.data.nodeType == "group" &&
          dropNode.data.nodeType == "group" &&
          this.dropCheck(dropNode, "group")
        ) {
          return true;
        } else if (
          draggingNode.data.nodeType == "point" &&
          dropNode.data.nodeType == "group" &&
          this.dropCheck(dropNode, "point")
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    allowDrag(draggingNode) {
      if (draggingNode) {
        if (
          draggingNode.parent.data[0] &&
          draggingNode.parent.data[0].name == ""
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    handleDragEnd(draggingNode, dropNode, dropType) {
      if (dropType != "none") {
        this.changesOfNodes.push({
          draggingNode: draggingNode,
          dropNode: dropNode,
        });
      }
    },
    saveMoveNode() {
      this.moveNodes(this.changesOfNodes).then(() => {
        setTimeout(() => {
          this.reloadTree();
        }, 500);
      });
    },
  },
  watch: {
    moveActive() {
      if (this.moveActive == true) {
        this.changesOfNodes = [];
      }
    },
  },
};
</script>
<style>
#pane-tree div.el-tree.moving > div.el-tree-node {
  background-color: #f97b1414;
}
</style>
<style scoped >
.selectAllButton {
  position: relative;
  padding: 5px;
  left: 15px;
  z-index: 1;
}
.resetAllButton {
  position: relative;
  padding: 5px;
  left: 15px;
  z-index: 1;
}
.createRootGroupButton:hover {
  opacity: 1;
}
.createRootGroupButton {
  opacity: 0.3;
  margin-top: 15px;
}
.control-group {
  opacity: 0;
  margin-left: 20px;
}
.el-tree-node__content:hover .control-group {
  opacity: 1;
}
.devices div {
  border: 1px solid black;
  padding: 5px;
  opacity: 0;
  margin: 5px;
}
.edit a {
  font-size: 10px;
  margin-left: 4px;
}
.edit {
  opacity: 0;
}
.tree-anchor:hover .edit {
  opacity: 1;
}
.tag {
  margin-left: 5px;
  background: rgb(51, 139, 221);
  border-radius: 5px;
  padding: 3px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 10px;
  border: 1px solid rgb(34, 90, 194);
  color: white;
}
ul {
  text-align: left;
  padding: 0px;
  padding-left: 10px;
  position: relative;
  overflow-x: visible;
}
li {
  padding-left: 0px;
}
.refreshButton {
  /* align-self: flex-end; */
  /* position: relative; */
  margin-right: 5px;
  margin-top: -30px;
  border-radius: 0px;
  padding: 5px;
  display: block;
  right: 0px;
  position: absolute;
  z-index: 999;
}
.moveButton {
  /* align-self: flex-end; */
  /* position: relative; */
  margin-right: 35px;
  margin-top: -30px;
  border-radius: 0px;
  size: 30px;
  padding: 5px;
  /* float: right; */
  position: relative;
  display: block;
  right: 0px;
  position: absolute;
  z-index: 999;
}
.moveSaveButton {
  /* align-self: flex-end; */
  /* position: relative; */
  margin-right: 35px;
  margin-top: -30px;
  padding: 5px;
  border-radius: 0px;
  /* float: right; */
  padding: 5px;
  position: relative;
  display: block;
  right: 0px;
  position: absolute;
  z-index: 999;
}
.quickSearch{
    width: 77% ;
    position: absolute;

    left: 10px;
    top: 9px;
}

</style>